import React, { useCallback, useState, Fragment } from 'react';
import Button from '../../../../../components/Button';
import CountOfTotal from '../../../../../components/CountOfTotal';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Select from '../../../../../components/input/Select/Select';
import Panel from '../../../../../components/outline/Panel';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_MEMO,
  MINIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT,
  RECOMMEND_REVIEW_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/recommendReviewConstants';
import recommendReviewSearchInfo from '../../../../../static/images/recommend/review/recommend-review-search-info.png';
import RecommendSearchInfoDrawer from '../../../common/RecommendSearchInfoDrawer';
import './RecommendReviewSaveInfo.scss';

const RecommendReviewSaveInfo = (props) => {
  const { form, setData, recommendReviewInfo, typeDisabled } = props;
  const { type, memo } = recommendReviewInfo;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawerVisible = useCallback(() => {
    setDrawerVisible(!drawerVisible);
  }, [drawerVisible]);

  return (
    <Panel className="recommend-review-save-info">
      <div className="panel-header">
        <div className="title">추천 상품 후기 정보</div>
        <Button isRadius color="primary" text="설명보기" onClick={toggleDrawerVisible} />
      </div>

      <div className="panel-body">
        {/* 추천 상품 후기 타입 */}
        <BaseForm
          label="추천 타입"
          content={
            <Select
              list={RECOMMEND_REVIEW_TYPE_SELECT_LIST}
              onChange={(value) =>
                setData({
                  path: ['recommendReviewSave', 'recommendReviewInfo', 'type'],
                  value,
                })
              }
              defaultValue={type}
              value={type}
              disabled={typeDisabled}
              isTable={false}
            />
          }
        />

        {/* 메모 */}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_MEMO} />
            </span>
          }
          initialValue={memo}
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_MEMO}
          onChange={(value) =>
            setData({
              path: ['recommendReviewSave', 'recommendReviewInfo', 'memo'],
              value,
            })
          }
          name="memo"
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      </div>

      <RecommendSearchInfoDrawer
        title="추천 상품 후기 - 검색 추천"
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
        imgUrl={recommendReviewSearchInfo}
      >
        <Fragment>
          <div>*앱에서 상품 후기 검색 탭에서 추천되는 상품 후기 리스트입니다.</div>
          <div>
            *추천 상품 후기 리스트는 최소 {MINIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT}개, 최대{' '}
            {MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT}개입니다.{' '}
          </div>
        </Fragment>
      </RecommendSearchInfoDrawer>
    </Panel>
  );
};

export default RecommendReviewSaveInfo;
